import axios from 'axios'

const oneinchApi = axios.create({
  baseURL: 'https://api.1inch.dev/swap/v6.1/',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

export default oneinchApi
